module.exports = __webpack_public_path__ + "img/e-class-sedan.8ca1c9c7.jpg";